import React from 'react'

function Hero() {
  return (
    <div>
        {/* <section id="hero" class="d-flex align-items-center">

            <div class="container" data-aos="zoom-out" data-aos-delay="100">
            <div class="row">
                <div class="col-xl-6">
                <h1>Bettter digital experience with Presento</h1>
                <h2>We are team of talented designers making websites with Bootstrap</h2>
                <a href="#about" class="btn-get-started scrollto">Get Started</a>
                </div>
            </div>
            </div>

        </section> */}
           <div class="container-fluid p-0 mb-5 wow fadeIn" data-wow-delay="0.1s">
        <div id="header-carousel" class="carousel slide" data-bs-ride="carousel">
            
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img class="w-100" src="assets/img/leo/s1.jpg" alt="Image" />
                    <div class="carousel-caption">
                        
                    </div>
                </div>
                <div class="carousel-item">
                    <img class="w-100" src="assets/img/leo/s2.jpg" alt="Image" />
                    <div class="carousel-caption">
                        
                    </div>
                </div>
                <div class="carousel-item">
                    <img class="w-100" src="assets/img/leo/s3.jpg" alt="Image" />
                    <div class="carousel-caption">
                        
                    </div>
                </div>
               
                </div>
            </div>
           
        </div>
        {/* <button class="carousel-control-prev" type="button" data-bs-target="#header-carousel"
                data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#header-carousel"
                data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>  */}
  
    </div>
  )
}

export default Hero